import Card from "../Card";

const Serenity = () => (
  <Card
    image="/images/fleet/serenity/dji_fly_20260726_110210_0006_1785084760932_photo.jpg"
    title="Serenity"
    titleLink="/fleet/serenity"
    subtitle="Rugged • Powerful • Luxurious | Arriving November 2026"
    description="Rugged on the outside with serious towing power and presence. Elegant and luxuriously comfortable inside.Serenity is your mobile home and office - rugged, powerful, and refined. <br /><br />Ready to take you across the country in comfort."
    ctaText="Learn More"
    ctaLink="/fleet/serenity"
    variant="image-right"
  />
);

export default Serenity;
